import React, { useContext, useState } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import Button from '@Components/Buttons/Button'
import { StoresContext } from '@App/contexts'
import { useParams } from 'react-router'
import { OverclaimUploadedDocument } from '@Entities/overclaim/overclaim-uploaded-document'
import { PARAM } from '@App/navigation/param'
import AddDescriptionForm from '@Components/OverclaimView/DocumentForms/AddDescriptionForm'
import { UPLOAD_OC_DOC_DESCRIPTION_HELP_TEXT } from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentUploadForm'

export interface EditUploadedDocumentsFormProps {
    overlaimUploadedDocument: OverclaimUploadedDocument
    onSaveClicked: () => void
}

const EditUploadedDocumentsForm = ({ onSaveClicked, overlaimUploadedDocument }: EditUploadedDocumentsFormProps) => {
    const [updatedDescription, setUpdatedDescription] = useState<string>(overlaimUploadedDocument.description || '')

    const { overclaimViewStore } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()

    const overclaimHeaderId = params.overclaimHeaderId && +params.overclaimHeaderId

    const updateDescription = async () => {
        if (updatedDescription && overclaimHeaderId) {
            await overclaimViewStore.updateOverclaimDocumentDescription(overlaimUploadedDocument, updatedDescription)
        }
        onSaveClicked()
    }

    return (
        <div className="upload-documentation-form">
            <h3>Edit Document Description</h3>

            <div className="files-preview">
                <div>
                    <div className="file-item">
                        <div className="file-preview-name-container">
                            <b>{overlaimUploadedDocument.name}</b>
                            <div>{Math.floor(overlaimUploadedDocument.size / 1000)} KB</div>
                        </div>
                    </div>
                    <AddDescriptionForm
                        descriptionHelpText={UPLOAD_OC_DOC_DESCRIPTION_HELP_TEXT}
                        setDescription={setUpdatedDescription}
                        description={updatedDescription}
                    />
                </div>
            </div>

            <div className="upload-files-button-container">
                <Button className="done-button" mainColor type="primary" onClick={updateDescription}>
                    Save
                </Button>
            </div>
        </div>
    )
}

export default observer(EditUploadedDocumentsForm)
